"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./close"), exports);



//////////////////
// WEBPACK FOOTER
// ./src/shared/AuthenticationPopup/icons/index.ts
// module id = 243
// module chunks = 2